// extracted by mini-css-extract-plugin
module.exports = {"link":"Policies_link__3a7cc","links":"Policies_links__bCYGP","separator":"Policies_separator__34pTN","wrapper":"Policies_wrapper__3Z8EZ"};